// extracted by mini-css-extract-plugin
export default {"dialog":"SimpleInfoDialog_dialog__NaUmw","formButton":"SimpleInfoDialog_formButton__M5+U3"};